import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicEmptyAcademicYear({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 240 168"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <defs>
        <filter
          x="-8.3%"
          y="-9.3%"
          width="116.6%"
          height="125.9%"
          filterUnits="objectBoundingBox"
          id="pic-empty-academic-year_svg__a"
        >
          <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation={2} in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.2 0 0 0 0 0.207843137 0 0 0 0 0.196078431 0 0 0 0.08 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <path
          d="M78.5 54C76.94 53.27-.37 10.96.79 11.52 8.05 7.93 9.35.01 9.35.01l75.97 43.97c-1.2 5.9-2.12 7.34-6.81 10.03z"
          id="pic-empty-academic-year_svg__b"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h240v168H0z" />
        <path
          d="M81.4 12C44.25 19.72-4.82 79.48 11 115.2c15.11 34.1 34.43 53.41 75.5 39.6 38.38-12.92 49.84-22.93 85.5-13.47 34.68 9.2 51.27-19.77 60.5-50.68 4-13.39-.13-53.16-49.5-46.65-46.51 6.13-55.77-41.52-101.6-32z"
          fill="#E9EDFB"
        />
        <path
          d="M13.81 119.5c116.8-41 186.96-43.4 210.49-7.16-2.74 4.85-11.01 26.15-34.96 30.58-13.36 2.47-26.94-8.21-53.34-4.43-33.55 4.82-80.24 43.93-110.73 1.57-8.4-11.67-12.21-18.52-11.46-20.55z"
          stroke="#979797"
          fill="#8F9DD6"
          opacity={0.32}
        />
        <path
          d="M49.4 105.77c1.45-3.14 3.09-6.83 1.93-7.62s-3.63 1.6-5.7 4.48c-2.06 2.87-3.19 6.3-2.17 7.06 1 .76 4.47-.77 5.93-3.92z"
          fill="#CCC"
        />
        <path fill="#FECE00" d="M79.53 126.05l3.07 2.54-8.44 10.22-3.07-2.53z" />
        <path fill="#FFE266" d="M79.9 140.66l-3.88-.91 3.04-12.91 3.87.9z" />
        <g transform="translate(42 98)">
          <use
            fill="#000"
            filter="url(#pic-empty-academic-year_svg__a)"
            xlinkHref="#pic-empty-academic-year_svg__b"
          />
          <use fill="#FFF" xlinkHref="#pic-empty-academic-year_svg__b" />
        </g>
        <path
          d="M83.36 116.4l6.38 3.74c-1.15 5.15-3.39 8.96-6.7 11.44-1.8-.98-4.24-2.25-6.6-3.62 2.93-2.86 5.24-6.7 6.92-11.56z"
          fill="#FECE00"
        />
        <path
          d="M84.88 117.29l3.43 2c-1.93 5.95-4.17 9.77-6.71 11.45 0 0-1.8-.82-3.52-1.9a27.7 27.7 0 006.8-11.55z"
          fill="#FFE266"
        />
        <g transform="translate(54 49)">
          <path
            d="M68.44 53.57L4.15 30.3a1.8 1.8 0 01-.13-3.33L62.61.34a1.8 1.8 0 011.5 0l30.35 14 1.12.52 26.62 12.27a1.8 1.8 0 01-.03 3.28L69.78 53.53c-.42.19-.9.2-1.34.04z"
            fill="#666"
          />
          <path
            d="M36.76 54.22l-3.91 5.5s1.3 5.66 30.11 5.51c28.81-.15 31.09-5.5 31.09-5.5l-5.37-7.34-16.44-10.56-35.48 12.4z"
            fill="#333532"
          />
          <path fill="#666" d="M118.55 59.5l-2.55.08-2.85-27 2.63.68z" />
          <circle fill="#666" cx={117.9} cy={61.2} r={3.6} />
          <path
            d="M37.4 32.17l-4.55 27.66s32.72-10.57 61.2 0l-4.23-29.28s-31.9-12.07-52.41 1.62z"
            fill="#595858"
          />
        </g>
      </g>
    </svg>
  );
}

SvgPicEmptyAcademicYear.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicEmptyAcademicYear.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicEmptyAcademicYear svgRef={ref} {...props} />
));
export default ForwardRef;
